module.exports = __webpack_public_path__ + "static/media/7-斑马进度计划.fc52cf10.png";